var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-cy":"asset-component-result-month"}},[_vm._v("\n  "+_vm._s(_vm.months)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }